import Home from "./pages/Home";

import { createTheme, ThemeProvider } from "@mui/material/styles";

import background from "./media/upsurge.mp4";
import "./App.css";

function App() {
  const { palette } = createTheme();
  const { augmentColor } = palette;
  const createColor = (mainColor) =>
    augmentColor({ color: { main: mainColor } });
  const theme = createTheme({
    palette: {
      melancholygrey: createColor("#636363"),
      melancholypink: createColor("#997f95"),
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <div className="App">
        <div id="bgvideo">
          <video
            autoPlay={true}
            loop={true}
            name="media"
            id="video"
            src={background}
            muted
            type="video/mp4"
          ></video>
        </div>
        <Home />
      </div>
    </ThemeProvider>
  );
}

export default App;
